import { INPUT_SEPARATORS } from './Input.constants';
import { GetFinalDecimalValueProps, GetFinalValueProps } from './Input.types';
import {
  addSpacesBetweenNumbers,
  filterNonNumericChars,
  formatPhoneNumber,
  onlyNumbers,
} from '@/utils/helpers';

export const getFinalValue = ({
  value,
  isTel,
  isNumberWithSpaces,
  isNumber,
  maxLength,
}: GetFinalValueProps): string => {
  switch (true) {
    case isTel:
      return formatPhoneNumber(value);
    case isNumberWithSpaces:
      return addSpacesBetweenNumbers(value, maxLength);
    case isNumber:
      return onlyNumbers(value, maxLength);
    default:
      return maxLength ? value.slice(0, maxLength) : value;
  }
};

export const getPlaceholder = (
  isFocused: boolean,
  label?: string,
  placeholder?: string
) => {
  return label ? (isFocused ? placeholder : '') : placeholder;
};

export const hasSeparator = (value: string) => {
  return INPUT_SEPARATORS.some(separator => value.includes(separator));
};

export const getFinalDecimalValue = ({
  precision,
  value,
  isTel,
  isNumberWithSpaces,
  isNumber,
  maxLength,
}: GetFinalDecimalValueProps): string => {
  let [integerPart, decimalPart] = filterNonNumericChars(value).split(/[.,]/);

  if (decimalPart) {
    decimalPart = decimalPart.slice(0, precision);
  }

  integerPart = getFinalValue({
    value: integerPart,
    isTel,
    isNumberWithSpaces,
    isNumber,
    maxLength,
  });

  if (hasSeparator(value)) {
    const separator = value.includes(',') ? ',' : '.';
    return `${integerPart}${separator}${decimalPart}`;
  }

  return integerPart;
};
